// extracted by mini-css-extract-plugin
export var wrapper = "description-module--wrapper--eMzx4";
export var text = "description-module--text--FDe43";